module.exports = __webpack_public_path__ + "img/1509026505.796e03f9.jpg";